import axios from "axios";
import { apiUrl } from "../../App";

export async function updateUserUsernameUseCase(id: string, variables: any) {
  return await axios.patch(`${apiUrl}/admin/users/${id}/username`, variables, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });
}
